import { render, staticRenderFns } from "./purchrecord.vue?vue&type=template&id=1484c978&scoped=true"
import script from "./purchrecord.vue?vue&type=script&lang=js"
export * from "./purchrecord.vue?vue&type=script&lang=js"
import style0 from "./purchrecord.vue?vue&type=style&index=0&id=1484c978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1484c978",
  null
  
)

export default component.exports